
















































import IMenu from '@/interfaces/IMenu';
import { defineComponent, onBeforeUnmount, onMounted, PropType, ref, watch } from '@vue/composition-api';
import Spinner from './Spinner.vue';
import Dropdown from './Dropdown.vue';

export default defineComponent({
  components: { Spinner, Dropdown },
  inheritAttrs: false,
  name: 'Sidebar',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingMessage: {
      type: String,
      default: 'Vent venligst ...'
    },
    padding: {
      type: String,
      default: 'p-4'
    },
    title: {
      type: String,
      required: false
    },
    allowFullscreen: {
      type: Boolean,
      required: false
    },
    menuItems: {
      type: Array as PropType<IMenu[]>,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { root }) {
    const show = ref(false);
    const fullscreen = ref(false);

    let scrollPosition = 0;

    const onKey = (e: KeyboardEvent) => {
      if (e.code == 'Escape') root.$router.back();
    };

    function disableScrolling() {
      scrollPosition = window.pageYOffset;
      const $body = document.querySelector('body');
      if ($body) {
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${scrollPosition}px`;
        $body.style.width = '100%';
      }
    }

    function enableScrolling() {
      const $body = document.querySelector('body');
      if ($body) {
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
      }
    }

    onMounted(() => {
      window.addEventListener('keyup', onKey, false);
      disableScrolling();
      setTimeout(() => {
        show.value = true;
      }, 80);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('keyup', onKey);
      enableScrolling();
    });

    watch(
      () => props.allowFullscreen,
      newValue => {
        if (newValue == false) fullscreen.value = false;
      }
    );

    return {
      fullscreen,
      show
    };
  }
});
